module.exports = __webpack_public_path__ + "img/86.3d64fdb2.png";